
import { Box, Text, Avatar } from "@flexisaf/flexibull2";
import Theme from "../../theme";
import { Colors } from "../../theme";
import styled from "styled-components";
const ResolvedFeedbackList = ({ feedback, handleRedirect }) => {
  return (
    <FeedbackCell key={feedback?.id}>
      <Box>
        <CardTop>
        <Box
            margin="10px 0"
            style={{ display: "flex", alignItems: "center", gap: "0.5rem"  }}
          >
            <Text bold>Paper Name:</Text>
            <Text color={Colors.Grey700} style={{ fontWeight: 500 }}>
              {feedback?.question?.paper?.name}
            </Text>
          </Box>
          <Box style={{ display: "flex", alignItems: "center", gap: "0.5rem" }}>
            <Text bold>Topic:</Text>
            <Text color={Colors.Grey700} style={{ fontWeight: 500 }}>
              {feedback?.question?.topic}
            </Text>
          </Box>
        </CardTop>
      </Box>
      <CardBody onClick={handleRedirect}>
        <Box className="user_choice">
          <Text color={Theme.PrimaryGrey}>
            There is an issue with the question
          </Text>
        </Box>

        <Box className="user_feed">
          <Text>
            {feedback?.message === "" ? "No message" : feedback?.message}
          </Text>
        </Box>
      </CardBody>
      <CardFooter>
        <Box display="flex" style={{ alignItems: "center", color: "#757575" }}>
          <Avatar
            name={`SAFlearn Admin`}
            margin="0 10px 0 0"
            size="30px"
            round
          />
          <Text>SAFlearn admin</Text>
        </Box>
      </CardFooter>
    </FeedbackCell>
  );
};

export default ResolvedFeedbackList;

const FeedbackCell = styled(Box)`
  background-color: #fff;
  border-radius: ${Theme.PrimaryRadius};
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  height: 270px;
  box-shadow: 0px 2px 15px -4px rgba(0, 0, 0, 0.1);
  overflow: hidden;

  .user_choice {
    font-size: 14px;
    border-left: 3px solid #187a97;
    color: #424242;
    margin-left: 20px;
    padding: 0.35rem;
  }
  .user_feed {
    font-size: 14px;
    color: #424242;
    margin: 10px;

    max-height: 90px;
    overflow-y: auto;
    padding: 0px 1.05rem;
  }
`;

const CardTop = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 4px 1rem;
  justify-content: space-between;
  border-bottom: 1px solid #e8e8e8;
`;

const CardBody = styled.div`
  cursor: pointer;
  position: relative;
  height: 110px;
`;
const CardFooter = styled.div`
  padding: 1.1rem;
  margin-top: -15px;
`;
